/* global API */

import dataLayerHelper from '../helpers/dataLayer';

const SUCCESS_DURATION = 3500;

const singleProduct = {
  initialize() {
    this.createEvents();
  },

  createEvents() {
    $('body').on('submit', '.js-single-product-form', (e) => {
      e.preventDefault();
      const $form = $(e.currentTarget);
      this.submitForm($form);
    });

    $('.product-variant-dropdown').change((e) => {
      const dropdown = $(e.target).parents('form').find('input[name=quantity]');
      dropdown.attr('min', $(e.target).find('option:selected').data('min'));
      dropdown.trigger('blur');
    });
  },

  /**
   * Change the button state to waiting, success or done
   * @param {Object} $form jQuery form element
   * @param {String} state waiting, success or done
   * @return {void}
   */
  changeButtonState($form, state) {
    const $btn = $form.find('[type="submit"]');

    // Disable the button on waiting state
    $btn.prop('disabled', state === 'waiting');

    // Hide all labels initially
    $btn.find('.js-state-done, .js-state-success, .js-state-waiting')
      .prop('hidden', true)
      .attr('aria-hidden', true);

    // Get the label to show
    const label = `.js-state-${state}`;
    const $label = $btn.find(label);

    // Show the label
    if ($label.length) {
      $label
        .prop('hidden', false)
        .attr('aria-hidden', false);
    }
  },

  /**
   * Post form to the API
   * @param {Object} $form jQuery form element
   * @return {void}
   */
  submitForm($form) {
    const data = new FormData($form[0]);

    this.changeButtonState($form, 'waiting');

    $.ajax({
      url: API.addSingleProduct,
      data,
      processData: false,
      contentType: false,
      type: 'POST',
      success: () => {
        this.changeButtonState($form, 'success');

        if (typeof $form.data('product') !== 'undefined') {
          this.addToGTM($form.data('product'));
        }

        setTimeout(() => {
          this.changeButtonState($form, 'done');
        }, SUCCESS_DURATION);

        $(document).trigger('cart:update');
      },
      error: (err) => {
        throw new Error(`${err.statusText} - ${API.addSingleProduct}`);
      },
    });
  },

  addToGTM(product) {
    // Shoot products into Tag Manager and wait for completion
    dataLayerHelper.addProduct(product);
  },
};

export default singleProduct;
